import CrossIcon from '@atlaskit/icon/glyph/cross';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../../messages/sign-up-form';
import {
  AnalyticsTrackType,
  BitbucketWorkspaces,
  ProductKeys
} from '../../../../../model/wac-signup-form';
import { InfoBox } from './info-box';
import { ModalContents } from './styled';

export type BitbucketJiraInfoBoxProps = {
  readonly productsExisting: string[];
  analyticsTrack: AnalyticsTrackType;
  bitbucketWorkspaces?: BitbucketWorkspaces;
};

export function BitbucketJiraInfoBox({
  productsExisting,
  analyticsTrack,
  bitbucketWorkspaces
}: BitbucketJiraInfoBoxProps) {
  const { segment } = analyticsTrack;

  let hasOtherProducts = false;
  let hasBitBucket = false;
  let hasJiraSoftware = false;
  let infoText: FormattedMessage.MessageDescriptor = messages.infoBoxDefault;

  const [isModalOpen, setModalBoxOpen] = useState(false);

  productsExisting.map((productKey) => {
    switch (productKey) {
      case ProductKeys.BITBUCKET:
        hasBitBucket = true;
        break;
      case ProductKeys.JIRA_SOFTWARE:
        hasJiraSoftware = true;
        break;
      default:
        hasOtherProducts = true;
    }
  });

  useEffect(() => {
    if (!!bitbucketWorkspaces) {
      let userstate = '';
      if (hasOtherProducts && !hasBitBucket && !hasJiraSoftware) {
        userstate = 'noBB_noJSW_yesOtherSite';
        segment('bxp.try.signup.initialversionshown', { userstate });
      } else if (hasJiraSoftware && !hasBitBucket) {
        userstate = 'noBB_yesJSW';
        segment('bxp.try.signup.initialversionshown', { userstate });
      } else if (!hasOtherProducts && hasBitBucket && hasJiraSoftware) {
        userstate = 'yesBB_yesJSW_noOtherSite';
        segment('bxp.try.signup.initialversionshown', { userstate });
      } else if (hasBitBucket && !hasJiraSoftware && !hasOtherProducts) {
        userstate = 'yesBB_noJSW_noOtherSite';
        segment('bxp.try.signup.initialversionshown', { userstate });
      } else if (hasOtherProducts && hasBitBucket && !hasJiraSoftware) {
        userstate = 'yesBB_noJSW_yesOtherSite';
        segment('bxp.try.signup.initialversionshown', { userstate });
      } else if (hasOtherProducts && hasBitBucket && hasJiraSoftware) {
        userstate = 'yesBB_yesJSW_yesOtherSite';
        segment('bxp.try.signup.initialversionshown', { userstate });
      }
    }
  }, [bitbucketWorkspaces]);

  if (hasOtherProducts && !hasBitBucket && !hasJiraSoftware) {
    infoText = messages.infoBoxSite;
  } else if (hasJiraSoftware && !hasBitBucket) {
    infoText = messages.infoBoxSiteJsw;
  } else if (!hasOtherProducts && hasBitBucket && hasJiraSoftware) {
    infoText = messages.infoBoxBb;
  } else if (hasBitBucket && !hasJiraSoftware && !hasOtherProducts) {
    infoText = messages.infoBoxBb;
  } else if (hasOtherProducts && hasBitBucket && !hasJiraSoftware) {
    infoText = messages.infoBoxSiteBb;
  } else if (hasOtherProducts && hasBitBucket && hasJiraSoftware) {
    infoText = messages.infoBoxSiteBb;
  }

  if (!(infoText.defaultMessage && infoText.defaultMessage.length > 1)) {
    return null;
  } else {
    return (
      <InfoBox>
        <p>
          <FormattedMessage {...infoText} />
        </p>
        <p className="link" onClick={() => setModalBoxOpen(true)}>
          <FormattedMessage {...messages.infoBoxModalCta} />
        </p>
        <ModalTransition>
          {isModalOpen && (
            <ModalDialog onClose={() => setModalBoxOpen(false)} width="370px">
              <ModalContents>
                <div className="message">
                  <SanitizedFormattedHtmlMessage {...messages.infoBoxModal} />
                </div>
                <span className="exit" onClick={() => setModalBoxOpen(false)}>
                  <CrossIcon label="" size="medium" />
                </span>
              </ModalContents>
            </ModalDialog>
          )}
        </ModalTransition>
      </InfoBox>
    );
  }
}
